import React from 'react';
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import editIcon from "../../../assests/bosEdit.svg";
import deleteIcon from "../../../assests/deleteIcon.svg";
import searchIcon from "../../../assests/search.svg";
import LoadingSpinner from "../../Loading/component";
import { useNavigate } from "react-router-dom";
import './productBrandList.css';

const ProductCategoriesComponent = ({
  categories,
  loading,
  searchTerm,
  setSearchTerm,
  onCreateCategory,
  onEditCategory,
  onDeleteCategory,
  onCategoryClick,
  canPerformActions = true,
}) => {
  const navigate = useNavigate();

  // Plus icon SVG component
  const PlusIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  // Handle category card click
  const handleCategoryCardClick = (category) => {
    if (onCategoryClick) {
      onCategoryClick(category);
    }
  };

  // Handle edit button click
  const handleEditClick = (e, category) => {
    e.stopPropagation();
    onEditCategory(category);
  };

  // Handle delete button click
  const handleDeleteClick = (e, category) => {
    e.stopPropagation();
    onDeleteCategory(category);
  };

  return (
    <div className="categories-container">
      <Sidebar />
      
      {loading && (
        <div className="full-page-loader">
          <LoadingSpinner />
        </div>
      )}

      <div className="categories-content">
        {/* Header */}
        <div className="categories-header">
          <button className="back-btn" onClick={() => navigate(-1)}>
            ←
          </button>
          <h1>Product Categories</h1>
        </div>

        {/* Search Section */}
        <div className="categories-search-section">
          <div className="search-wrapper">
            <img src={searchIcon} alt="search" className="search-icon" />
            <input
              type="text"
              placeholder="Search Category by Name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
        </div>

        {/* Categories Grid */}
        <div className="categories-grid">
          {/* Create New Category Card */}
          <div className="category-card create-card" onClick={onCreateCategory}>
            <div className="create-card-content">
              <div className="plus-icon-wrapper">
                <PlusIcon />
              </div>
              <span className="create-card-text">Create New Category</span>
            </div>
          </div>

          {/* Existing Categories */}
          {categories.length > 0 ? (
            categories.map((category) => (
              <div 
                key={category.id} 
                className="category-card"
                onClick={() => handleCategoryCardClick(category)}
              >
                {/* Action Buttons */}
                {canPerformActions && (
                  <div className="category-card-actions">
                    <button 
                      className="action-icon edit-icon"
                      onClick={(e) => handleEditClick(e, category)}
                      title="Edit"
                    >
                      <img src={editIcon} alt="Edit" />
                    </button>
                    <button 
                      className="action-icon delete-icon"
                      onClick={(e) => handleDeleteClick(e, category)}
                      title="Delete"
                    >
                      <img src={deleteIcon} alt="Delete" />
                    </button>
                  </div>
                )}

                {/* Category Image */}
                <div className="category-card-image">
                  <img 
                    src={category.image_url} 
                    alt={category.name}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=400&fit=crop";
                    }}
                  />
                </div>

                {/* Category Name */}
                <div className="category-card-name">{category.name}</div>

                {/* Subcategory Count */}
                {category.subCategories && category.subCategories.length > 0 && (
                  <div className="subcategory-count">
                    {category.subCategories.length} Subcategories
                  </div>
                )}
              </div>
            ))
          ) : (
            !loading && (
              <div className="no-categories">
                <div className="no-data-icon">📁</div>
                <p>No categories found</p>
                {searchTerm && <small>Try a different search term</small>}
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCategoriesComponent;